import { gql } from '@apollo/client';
const SET_WAREHOUSE_RELEASE_COMPONENT_VARIANT_TO_READY = gql `
  mutation SetWarehouseReleaseComponentVariantToReady($warehouseReleaseComponentVariantId: ID!) {
    setWarehouseReleaseComponentVariantToReady(
      warehouseReleaseComponentVariantId: $warehouseReleaseComponentVariantId
    ) {
      warehouseReleaseComponentVariant {
        id
      }
    }
  }
`;
export default SET_WAREHOUSE_RELEASE_COMPONENT_VARIANT_TO_READY;
